/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon64Regular = forwardRef('UiMenuDots8VIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M25 17.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M25 29.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M28.5 38a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M25 53.502a3.5 3.5 0 1 0 0-7.002 3.5 3.5 0 0 0 0 7.002Z" }),
        React.createElement("path", { d: "M42.5 14a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M39 29.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M42.5 38a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M39 53.502a3.5 3.5 0 1 0 0-7.002 3.5 3.5 0 0 0 0 7.002Z" })));
});
